import script from "./basicInformation.vue?vue&type=script&setup=true&lang=js"
export * from "./basicInformation.vue?vue&type=script&setup=true&lang=js"

import "./basicInformation.vue?vue&type=style&index=0&id=6b2739f6&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b2739f6"]])

export default __exports__